export default defineNuxtRouteMiddleware(() => {
  const cookieManager = useCookieManagerStore()
  const { cookie } = useRequestHeaders(['cookie'])

  // sync request cookie and state cookie
  cookieManager.saveRequestCookies(cookie ?? '')
})
